import React from 'react';
import styled from "styled-components";
import Colours from '@shared/ui/atoms/Colours';
import Icon, { IconTypes } from '@shared/ui/atoms/icon/Icon';
import { BodyRegular } from '@shared/ui/atoms/fonts/Body';
import { useTranslation } from "react-i18next";

export function SidebarItem(props: Props) {
  const {t} = useTranslation();
  if (props.active) {
    return (
      <Container onClick={props.onClick}>
        <SelectedContent>
          <Icon icon={props.icon} color={Colours.white} />
          <BodyRegular colour={Colours.white} weight={600}>{t(props.label)}</BodyRegular>
        </SelectedContent>
      </Container>
    )
  } else {
    return (
      <Container onClick={props.onClick}>
        <Content>
          <Icon icon={props.icon} />
          <BodyRegular>{t(props.label)}</BodyRegular>
        </Content>
      </Container>
    )
  }
}

interface Props {
  icon: IconTypes;
  label: string;
  active: boolean;
  onClick: () => any;
}

const Container = styled.div`
  display: flex;
  cursor: pointer;
  margin-bottom: 8px;
  * {
    user-select: none;
  }
  i {
    margin-right: 10px;
  }
`

const Content = styled.div`
  flex: 1;
  padding: 8px 16px;
  display: inline-flex;
  border-radius: 8px;
`

const SelectedContent = styled.div`
  flex: 1;
  background-color: ${Colours.darkBlue};
  padding: 8px 16px;
  display: inline-flex;
  border-radius: 8px;
  box-shadow: 0 16px 22px 0 rgba(48, 48, 50, 0.23);
`
